module.exports = __webpack_public_path__ + "img/diapositiva-10-4.1315545b.jpg";